export default {
    title: '',
    period: null,
    period_type: 1,
    color: null,
    white_text: false,
    order: 0,
    is_last: false,
    unsubscribe_period: null
};

